import { useContext } from "react";
import { createCall } from "../api/Apicall";
import { Context } from "../components/containers/context/Context";
import { ShowMessage } from '../components/UI/showMessage/ShowMessage';
import { TexTranslate, TexTranslateDefault } from  "../translations/FlattenMessages";
import { useIntl } from "react-intl";
import { useLoader } from '../hooks/useLoader';
import { ShowMessageTknExp } from "../helpers/Utils";
import { Base64 } from "js-base64";

export const useLoginCore = () => {

    const intl = useIntl();

    const loadSession = async () => {
        window.location.reload();
    };

    const txtLoad = TexTranslateDefault(intl, "general.Loading...");
    const {hideLoader} = useLoader({"textLoader" : txtLoad});

    const processLogOutMsg = () => {
        ShowMessage(
            {
                title: TexTranslate(intl, "general.Warning"),
                message: TexTranslate(intl, "general.For security reasons"),
                typeMessage: "warning",
                confirmButtonText: TexTranslate(intl, "general.accept"),
                callbackConfirm: (() => {
                    loadSession();
    
                })
            }
        );
    };
    
    const { app, user } = useContext(Context);

    const loginCore = async ({param,setData,value}) => {
        let response;
        let url;
        let buf;
        let bodyToken = {};
        let idiomaValue;
        let tokenValue;
        let keyClientValue;
        try {
            param = param ? param : {};
            idiomaValue = value?.idioma ? value.idioma : undefined;
            tokenValue = value?.token ? value.token : undefined;
            keyClientValue = value?.keyClient ? value.keyClient : undefined;
            param.tokenIP4 = true;
            param.idiomaIP4 = idiomaValue || sessionStorage.getItem("idioma") || 'es';
            const token = tokenValue || sessionStorage.getItem("token") || sessionStorage.getItem("userRedirect");
            bodyToken.token = token;
            const keyClient = keyClientValue || sessionStorage.getItem("keyClient");
            bodyToken.keyClient = keyClient ? keyClient : undefined;
            bodyToken.login = 'one';

            url = createCall({
                base: `${app.apiCore}/control/LoginControl.jsp` , 
                params : param
            });

            buf = Base64.encode(JSON.stringify(bodyToken));
            
            const respFetch = await fetch(url,{
                    method:'POST',
                    body: buf,
                    credentials : "include"
                }        
            );

            if (respFetch.status === 401) {

                ShowMessageTknExp(app, user);
    
                const loader = document.getElementById("loader");

                if (loader) {
                    loader.style.display = 'none';
                }
                return;
            }

            const result = await respFetch.json();
             
            if ( result.errorMsg === 'invalidToken' ) {
                 hideLoader();
                 return processLogOutMsg();                 
             }

            if ( result && result.success === true) {
               response = result;
            } else if (result.errorMsg ) {
                response = {...result, success : false , msg : result.errorMsg};
            } else if (result.error_code ) {
                    response = {...result, success : false , msg : result.error_code};
            } else {
                response = result;
                response.msg = "login.core.error";
            }
            if(response && setData) {
                setData(response);
            }
            return response;
        } catch (error) {
            console.log(error);
            if(setData){
                setData({ success : false, "msg" : "error"});
            }
            return { success : false, "msg" : "error"};
        }
    };

    return {
        loginCore
    };

}

export const processResponseLoginCore = ({msg,msgParams,TexTranslate,intl}) => {
    let result;
    let param;
    const StrParams = (msg, params)=>{
        params.forEach((element, index) => {
            msg = String(msg).replace(`((${index}))`, element);
        });
        return msg;  
    }

    switch (msg) {
        case "error.user.notActive":
            result = TexTranslate(intl, "login.error_user_notActive", "login.error");
            break;
        case "error.user.faliurePassword":
            result =TexTranslate(intl, "login.error_faliurePassword", "login.error");
            break;
        case "You do not have authorization to connect from IP {0}. Please, consult the administrator or contact technical support":
        case "error.user.faliureIP":
            if(msgParams){
                param = [msgParams.IP]
                result = StrParams(TexTranslate(intl, "login.error_faliureIP", "login.error"),param);
            } else {
                result = StrParams(TexTranslate(intl, "login.error_faliureIP", "login.error"),["0.0.0.0"]);
            }
            
            break;
        case "invalid data":
            result = TexTranslate(intl, "login.error_invalidData", "login.error");
            break;
        case "You don't have permissions to access the selected client !!":
            result = TexTranslate(intl, "login.error_clientPermissions", "login.error");
            break;
        default:
            break;
    }
    return result;

}

export const useCloseSessionCore = () => {

    const { app } = useContext(Context);

    const closeSessionCore = async ({param,setData}) => {
        let response;
        let url;
        try {
            param = param ? param : {};
            param.borrar_sesion = true;
            param.redirect = sessionStorage.getItem("userRedirect");

            url = createCall({
                base: `${app.apiCore}/control/MainControl.jsp` , 
                params : param
            });

            const respFetch = await fetch(url,{
                    method:'POST',
                    credentials : "include"
                }        
            );

            const result = await respFetch.json();

            if ( result !== undefined ) {
               response = result;
            } else {
                response = { success : false, "msg" : "error.closeSesion"};
            }
            if(response && setData) {
                setData(response);
            }
            return response;
        } catch (error) {
            console.log(error);
            if(setData){
                setData({ success : false, "msg" : "catch.closeSesion"});
            }
            return { success : false, "msg" : "catch.closeSesion"};
        }
    };

    return {
        closeSessionCore
    };

}